export default __webpack_public_path__ + "static/media/icon_transfer.9422c986.svg";